import ProductHeaderInterface from '../../components/Header/CartHeader/interfaces/ProductHeaderInterface';
import ListCartHeaderInterface from '../../components/Header/CartHeader/interfaces/ListCartHeaderInterface';

const formatListCartHeader = (
  dataCartItems: any,
  formattedTotal: string,
  totalCart: number
) => {
  const listProducts: ListCartHeaderInterface = {};

  Object.values(dataCartItems).forEach((itemCart: any, index) => {
    const productAdded: ProductHeaderInterface = {
      idPanier: itemCart.product.id,
      referenceId: itemCart.product.referenceId,
      titreProduit: itemCart.product.title,
      url: itemCart.product.url,
      formattedPrice: itemCart.product.formattedPrice,
      prixTTC: itemCart.product.price.price,
      img: itemCart.img,
      qte: itemCart.quantity,
      formattedBeforeDiscountPrice: itemCart.formattedBeforeDiscountPrice
        ? itemCart.formattedBeforeDiscountPrice
        : null,
      formattedTotalPrice: formattedTotal,
      totalCart,
    };

    listProducts[index] = productAdded;
  });

  return listProducts;
};

export default formatListCartHeader;
